import { memo, CSSProperties } from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface FilePreviewLoadingStateProps {
  message: string;
  className?: string;
  isFullScreen?: boolean;
  style?: CSSProperties;
}

export const FilePreviewLoadingState = memo(
  ({
    message,
    className,
    isFullScreen,
    style,
  }: FilePreviewLoadingStateProps) => (
    <div
      className={cn(
        "flex items-center justify-center bg-gray-100 rounded-lg p-8 w-full",
        { "h-full": isFullScreen },
        className,
      )}
      style={style}
    >
      <div className="text-center">
        <Loader2 className="h-12 w-12 mx-auto mb-3 text-gray-600 animate-spin" />
        <p className="text-gray-700 font-medium">{message}</p>
      </div>
    </div>
  ),
);
